import '../styles/Primitives.scss';
import { mergeSx } from '../_internal/styleProps';

const responsiveStyles = (name, value, transform = (item) => item) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return { [`--stack-${name}-xs`]: transform(value) };
  }

  return Object.fromEntries(
    ['xs', 'sm', 'md', 'lg', 'xl']
      .filter((breakpoint) => value[breakpoint] != null)
      .map((breakpoint) => [`--stack-${name}-${breakpoint}`, transform(value[breakpoint])])
  );
};

export default function Stack({ alignItems, children, className = '', direction = 'column', flexWrap, gap, justifyContent, spacing = 0, style, sx, useFlexGap, ...props }) {
  void useFlexGap;
  const spacingValue = gap ?? spacing;
  return <div className={`ui-stack ${className}`.trim()} style={{
    ...responsiveStyles('direction', direction),
    ...responsiveStyles('align', alignItems),
    ...responsiveStyles('gap', spacingValue, (value) => typeof value === 'number' ? `${value * 8}px` : value),
    justifyContent,
    flexWrap,
    ...mergeSx(sx, style),
  }} {...props}>{children}</div>;
}
